<template>
<div>
<h1>Test webpay Return</h1>
{{resp}}
</div>
</template>
 
<script>
import axios from 'axios'
export default {
    data: function () {
        return {
            resp : ''
        }
    },
    methods:{
   
    }, 
    created(){
        axios({url: process.env.VUE_APP_API_URL+'webpay/final', method: 'GET' })
        .then(resp => {		
            console.log(resp.data)
            this.resp = resp.data
        })
    } 
}
</script> 

